import styled from "@emotion/styled";
import { neutralLight40 } from "../../../constants/colors";
import { Spacer } from "../../layout";

interface ContainerProps {
    variant: "inline" | "floating";
}

export const Container = styled(Spacer)<ContainerProps>`
    background: ${neutralLight40};
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 6px;
    border-radius: 4px;
    width: fit-content;
    box-shadow: ${(props) => (props.variant === "floating" ? "0px 8px 24px rgba(0, 0, 0, 0.12)" : "none")};
`;
